import { MutableRefObject } from 'react';
import { BlockNoteDocument } from '../schema';
import { prepareDocumentForPersist } from './sync-table-column-widths-in-document';

export default function emitPreparedDocument(
  editor: Parameters<typeof prepareDocumentForPersist>[0],
  document: Parameters<typeof prepareDocumentForPersist>[1],
  editorValueRef: MutableRefObject<string>,
  onChange?: (document: BlockNoteDocument) => void,
  options?: Parameters<typeof prepareDocumentForPersist>[2],
) {
  const commit = () => {
    const canMeasureTablesFromDom =
      options?.measureAllTableWidthsFromDom && !!editor.domElement;
    const prepared = prepareDocumentForPersist(editor, document, {
      ...options,
      measureAllTableWidthsFromDom: !!canMeasureTablesFromDom,
    });
    const preparedStr = JSON.stringify(prepared);
    if (preparedStr === editorValueRef.current) {
      return;
    }
    editorValueRef.current = preparedStr;
    onChange?.(prepared);
  };

  commit();

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(commit);
  }
}
